import LocalizedLink from "components/LocalizedLink";

export default LocalizedLink;
